import {Link} from 'react-router-dom';
import {useAppParams} from '~/pages/context/AppParamsContext';

function Footer() {
    const {getParamValueById} = useAppParams();
    return (
        <footer id="footer" className="footer dark-background">
            <div className="container-medium pt-6">
                <div className="row gy-4">
                    <div className="col-lg-4">
                        <Link to="/home" className="text-decoration-none">
                            <h3 className="text-primary">BreakThrough AI Chatbot</h3>
                        </Link>
                        <div className="footer-contact pt-1">
                            <p className="mt-3 mb-1 fs-8"><strong>Phone:</strong> <span className='fs-8-1'>{getParamValueById(1)}</span></p>
                            <p className='fs-8'><strong>Email:</strong> <a href={`mailto:${getParamValueById(2)}`} className='fs-8-1 fw-semibold text-decoration-none'>{getParamValueById(2)}</a></p>
                        </div>
                        <div className="social-links d-flex mt-4">
                            <a href=""><i className="bi bi-twitter-x me-2"></i></a>
                            <a target="_blank" href={getParamValueById(3)}><i className="bi bi-facebook"></i></a>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <h4 className='pb-2'>Useful Links</h4>
                        <ul className="list-unstyled fs-8-1">
                            <li className='pb-2 fw-bold'><a href="#">Home</a></li>
                            <li className='pb-2 fw-bold'><a href="about-us">About us</a></li>
                            <li className='pb-2 fw-bold'><a href="our-service">Our Services</a></li>
                            <li className='pb-2 fw-bold'><a href="appointment">Appointment</a></li>
                            <li className='pb-2 fw-bold'><a href="pricing">Pricing</a></li>
                            <li className='pb-2 fw-bold'><a href="terms-condition">Terms and Condition</a></li>
                        </ul>
                    </div>

                    <div className="col-lg-4">
                        <h4 className='pb-2'>Our Services</h4>
                        <ul className="list-unstyled fs-8-1">
                            <li className='pb-2 fw-bold'><a href="#">Voice And Text Input</a></li>
                            <li className='pb-2 fw-bold'><a href="#">Multiple Query Attemps</a></li>
                            <li className='pb-2 fw-bold'><a href="#">Self-Awareness Stimulation</a></li>
                            <li className='pb-2 fw-bold'><a href="#">Deep Reflection &amp; Journaling</a></li>
                            <li className='pb-2 fw-bold'><a href="#">Privacy &amp; Security</a></li>
                            <li className='pb-2 fw-bold'><a href="#">Continuous Updates &amp; Support</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="text-center mt-4">
                <p className='pb-4 fs-9'>© <span>Copyright 2025</span> <strong className="px-1">BreakThrough AI Chatbot</strong>
                    <span>All Rights Reserved</span>
                </p>
            </div>
        </footer>
    )
}

export default Footer;